import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-condicoes{
    padding: 32px 0 0;
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow: hidden;
}

#seguro-auto-condicoes .condicoes-tabs {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 290px;
    height: 38px;
    margin: auto;
}

#seguro-auto-condicoes .condicoes-tabs button{
    display: flex;
    width: 145px;
    flex-direction: column;
    align-items: center;
    color: #222;
    text-align: center;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    background: none;
    border: none;
    border-bottom: 1px solid #767676;
}

#seguro-auto-condicoes .condicoes-tabs button.active {
    color: #C00;
    border-bottom: 2px solid #C00;
}



#seguro-auto-condicoes .condicoes-contain {
    border-radius: 4px;
    border: 1px solid #C00;
    position: relative;
    padding: 0 8px;
    padding-bottom: 34px;
}

#seguro-auto-condicoes .condicoes-contain-img {
    position: absolute;
    height: 167px; 
    top: 41px;
    left: calc(50% - 31px);;
    transform: translate(-50%, 0);
}

#seguro-auto-condicoes .condicoes-contain-titulo {
    margin-top: 241px;
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
}

#seguro-auto-condicoes .tab-santander-auto-condicoes,
#seguro-auto-condicoes .tab-zurich-condicoes {
    display: none;
}

#seguro-auto-condicoes .tab-santander-auto-condicoes.active,
#seguro-auto-condicoes .tab-zurich-condicoes.active {
    display: flex;
    flex-direction: column;
    gap: 47px;
    margin-top: 31px;
}

#seguro-auto-condicoes .cards-condicao {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
#seguro-auto-condicoes .card-condicao {
    display: flex;
    gap: 16px;
    align-items: center;
}

#seguro-auto-condicoes .card-condicao .condicao-textos {
    display: flex;
    flex-direction: column;
}

#seguro-auto-condicoes .card-condicao .condicao-textos-titulo {
    margin: 0;
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
} 

#seguro-auto-condicoes .card-condicao .condicao-textos-descricao {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 200;
    line-height: 22px;
}

#seguro-auto-condicoes .link-condicoes-antigas {
    display: inline-flex;
    width: 100%;
    max-width: 236px;
    margin: auto;
    padding: 0px 8px 8px 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    cursor: pointer;
}

#seguro-auto-garantido {
    padding-top: 40px;
}

#seguro-auto-garantido .seguro-auto-garantido-texto {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 22px;
}

@media (min-width: 992px) {
    #seguro-auto-condicoes .ctn-home-24 {
        max-width: 1279px;
    }

    #seguro-auto-condicoes .condicoes-contain {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 32px 0 34px;
        gap: 75px;
    }

    #seguro-auto-condicoes .condicoes-contain-img {
        position: relative;
        left: 0;
        margin-left: -230px;
        top: 0;
        height: 273px;
        transform: none
    }

    #seguro-auto-condicoes .condicoes-contain-conteudo {
        width: 50%;
    }

    #seguro-auto-condicoes .condicoes-contain-titulo {
        margin-top: 0;
    }

    #seguro-auto-condicoes .link-condicoes-antigas {
        margin: 0;
    }

    #seguro-auto-garantido {
        padding-bottom: 64px;
    }

    #seguro-auto-garantido .ctn-home-24 {
        max-width: 1200px;
    }
}`;

export default styles;